// class SearchForm extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input[type="search"]');
//     this.resetButton = this.querySelector('button[type="reset"]');

//     if (this.input) {
//       this.input.form.addEventListener('reset', this.onFormReset.bind(this));
//       this.input.addEventListener(
//         'input',
//         debounce((event) => {
//           this.onChange(event);
//         }, 300).bind(this)
//       );
//     }
//   }

//   toggleResetButton() {
//     const resetIsHidden = this.resetButton.classList.contains('hidden');
//     if (this.input.value.length > 0 && resetIsHidden) {
//       this.resetButton.classList.remove('hidden');
//     } else if (this.input.value.length === 0 && !resetIsHidden) {
//       this.resetButton.classList.add('hidden');
//     }
//   }

//   onChange() {
//     this.toggleResetButton();
//   }

//   shouldResetForm() {
//     return !document.querySelector('[aria-selected="true"] a');
//   }

//   onFormReset(event) {
//     // Prevent default so the form reset doesn't set the value gotten from the url on page load
//     event.preventDefault();
//     // Don't reset if the user has selected an element on the predictive search dropdown
//     if (this.shouldResetForm()) {
//       this.input.value = '';
//       this.input.focus();
//       this.toggleResetButton();
//     }
//   }
// }

// customElements.define('search-form', SearchForm);
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
      this.resetButton.addEventListener('click', this.onReset.bind(this));
      this.toggleResetButton();
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.input.value.length === 0;
    this.resetButton.classList.toggle('hidden', resetIsHidden);
  }

  onChange() {
    this.toggleResetButton();
    // You can add additional logic here, such as triggering search functionality
  }

  onReset(event) {
    event.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.toggleResetButton();
    // You can add additional logic here, such as resetting search results
     const searchResults = document.getElementById('predictive-search-results');
    if (searchResults) {
        searchResults.innerHTML = ''; // Clear search results
        searchResults.classList.add('hidden'); // Hide search results container if needed
    }
  }
}

customElements.define('search-form', SearchForm);